// extracted by mini-css-extract-plugin
module.exports = {"tooltipWrapper":"styles_tooltipWrapper__-BG62"};